import React from "react";
import { Link } from "react-router-dom";
import Assignment from '../../../src/shared/assets/images/svg/assignment_blue_larg.svg'
import ArrowRight from '../../../src/shared/assets/images/svg/open_side.svg'
import { useOwnerStatistics } from "./customer-home.service";
import { useQuery } from "react-query";
import { client } from "../../shared/helpers/client";
import _ from "lodash";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';


function  formatToK(num) {
    if (num > 1000) {
      return `${(num / 1000)?.toFixed(1)}k`;
    }
    return num?.toFixed(1);
}

function truncate(name, length = 15) {
  if (name.length > length) {
    return name.substring(0, length) + "...";
  }
  return name;
}

function CustomerHome() {
   const {ownerStatic}=useOwnerStatistics()
  const {data:tickets = []} = useQuery(['tickets'], () => client("/OwnerBooking/GetTicketsGrouped").then(r => r.response))
  return (
    <div className="rwafieHome">
      <div className="container">
        <div className="home-header">
          <h1 className="homeTitle">Welcome Back,</h1>
        </div>
        <div className="from-to-group">
          <div className="div-title">
            <img src={Assignment} alt="Assignment" />
            <h1 className="title">{ownerStatic?.name}</h1>
          </div>
          <div className="div-info">
           {ownerStatic?.officesCount > 0 && ( <Link to="/controlled-offices" className="offices">
              <h1>Controlled Offices</h1>
              <h2>{ownerStatic?.officesCount}</h2>
            </Link>)}
            <div className="ballance">
              <h1>Current Ballance</h1>
              <h2>{ Math.round((ownerStatic?.localBalance + Number.EPSILON) * 100) / 100} SAR</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="box-details">
              <h1>System Details</h1>
              <p>NAME:{ownerStatic?.name} <br />OFFICE NO.{ownerStatic?.custCode}</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <Link to="/bank-account" className="box-details">
              <h1>Rwafi Bank Accounts</h1>
              <p>List of all our banks for <br />Transfer</p>
            </Link>
          </div>
          <div className="col-lg-6 col-md-12">
              <div className="tickets-info">
                  <div className="tickets">
                    <h1>{formatToK(ownerStatic.ticktsCount)}</h1>
                    <h2>TICKETS</h2>
                  </div>
                <div className="div-report">
                <Carousel
                  ssr
                  deviceType="desktop"
                  arrows
                  itemClass=''
                  responsive={{
                    desktop: {
                      breakpoint: { max: 3000, min: 1024 },
                      items: 3,
                    }
                  }}
                >
                {tickets?.map((ticket) => {
                  const color = _.sample(["#7C5448", "#78CAFE", "#F9CD23"]);
                  return (
                    <div key={ticket.name}>
                      <CircularProgressbar value={ticket.rate * 100} text={`${ticket.count}`} styles={{
                        root: { width: 50 },
                        path: { stroke: color }
                      }} />
                      <p style={{
                        color,
                      }}> {truncate(ticket.name)} </p>
                    </div>
                  );
                })
                }
                </Carousel>
                </div>
                  {/*<div className="div-report flyEmirates">*/}
                  {/*  <div className="circle">620</div>*/}
                  {/*  <span>Fly Emirates </span>*/}
                  {/*</div>*/}
                  {/*<div className="div-report lofthansa">*/}
                  {/*  <div className="circle">620</div>*/}
                  {/*  <span>Egypt Air </span>*/}
                  {/*</div>*/}


              </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="box-chart">
              <h1 className="total">TOTAL TICKETS</h1>
              <p> {formatToK(ownerStatic.ticktsCount)}<span>Tickets</span></p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="box-chart">
              <h1 className="commissions">COMMISSIONS</h1>
              <p>{formatToK(ownerStatic.totalCommissions)} <span>SAR</span></p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="box-chart">
              <h1 className="vat-amount">VAT AMOUNT</h1>
              <p>{formatToK(ownerStatic.totalVats)} <span>SAR</span></p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="box-chart">
              <h1 className="net-amount">NET AMOUNT</h1>
              <p>{ownerStatic.totalNetAmounts?.toFixed(2)} <span>SAR</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


function RightArrow({ onClick, ...rest }) {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;

  return (
      <button onClick={() => onClick()} >
       <img src={ArrowRight} alt="ArrowRight" />
      </button>

  );
}

function LeftArrow({ onClick, ...rest }) {
  return (

      <button onClick={() => onClick()} >
        <img src={ArrowRight} alt="ArrowRight" />
      </button>

  );
}
export default CustomerHome;